module.exports = __webpack_public_path__ + "img/1524816374.fb402782.jpg";